module.exports = __webpack_public_path__ + "media/images/desktop/arrow-down-3-blake-c59cedb5ef990b4a89ecd9e877a6cfa8.svg";